import { useAppSelector } from '../../common/hooks/redux';
import {
  defaultRoutesByRole,
  isAppRole,
  rolePath,
  roles,
  type StoredAppRole,
} from './paths';

export function useAppRole(): StoredAppRole {
  return useAppSelector(state => {
    const role = String(
      state.auth?.user?.role || state.authorization?.user?.role || roles.NONE,
    ).toLowerCase();
    return isAppRole(role) ? role : roles.NONE;
  });
}

export function useRolePath() {
  const role = useAppRole();
  return (pagePath: string) => rolePath(role, pagePath);
}

export function useDefaultHomePath() {
  const role = useAppRole();
  return defaultRoutesByRole[role];
}
